import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'settings.mfa-section.title',
    defaultMessage: 'Multi-factor Authentication (MFA)',
  },
  subtitle: {
    id: 'settings.mfa-section.subtitle',
    defaultMessage: 'Set up MFA using an authenticator app (like Google Authenticator or Authy).',
  },
  enabled: {
    id: 'settings.mfa-section.enabled',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'settings.mfa-section.disabled',
    defaultMessage: 'Disabled',
  },
  enableAction: {
    id: 'settings.mfa-section.enableAction',
    defaultMessage: 'Enable MFA',
  },
  disableAction: {
    id: 'settings.mfa-section.disableAction',
    defaultMessage: 'Disable MFA',
  },
  recoveryLink: {
    id: 'settings.mfa-section.recovery-link',
    defaultMessage: 'Generate new recovery codes ',
  },
  errorEnableMFA: {
    id: 'settings.mfa-section.error-enable-mfa',
    defaultMessage: 'There was an error enabling MFA. Please try again.',
  },
  errorDisablingMFA: {
    id: 'settings.mfa-section.error-disabling-mfa',
    defaultMessage: 'There was an error disabling MFA. Please try again.',
  },
  successDisablingMFA: {
    id: 'settings.mfa-section.success-disabling-mfa',
    defaultMessage: 'MFA has been successfully disabled.',
  },
  disableMfaConfirmationTitle: {
    id: 'settings.mfa-section.disable-mfa-confirmation-title',
    defaultMessage: 'Disable MFA?',
  },
  disableMfaConfirmationMessage: {
    id: 'settings.mfa-section.disable-mfa-confirmation-message',
    defaultMessage:
      'Are you sure you want to disable multi-factor authentication (MFA)? This will reduce the security of your account.',
  },
  disableMfaConfirmationBtn: {
    id: 'settings.mfa-section.disable-mfa-confirmation-btn',
    defaultMessage: 'Disable MFA',
  },
  successGeneratingRecoveryCodes: {
    id: 'settings.mfa-section.success-generating-recovery-codes',
    defaultMessage: 'New recovery codes have been generated.',
  },
  errorGeneratingRecoveryCodes: {
    id: 'settings.mfa-section.error-generating-recovery-codes',
    defaultMessage: 'There was an error generating new recovery codes. Please try again.',
  },
});
